var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message",class:("is-" + _vm.type)},[(_vm.title)?_c('p',{staticClass:"message-title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"message-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }